import React, { useContext } from 'react';
import { ModalLayoutContext, ModalLayoutContextProps } from '../../ModalLayout';

/**
 * Allows for rendering a custom title for the dialog, to have the dialog
 * labeled by the title, when the default `Dialog.Header` can't be used.
 * Should not be used when the default Dialog.Header is used.
 * @param children render prop that accepts dom props to be applied on the title element
 */
export const DialogTitle = ({
  children,
}: {
  children: (
    titleProps: ModalLayoutContextProps['titleProps']
  ) => React.ReactNode;
}): JSX.Element => {
  return <>{children(useContext(ModalLayoutContext).titleProps)}</>;
};
